export function formatAccount(val: string): string {
  return val || "";
}
